import { useFieldArray, useFormContext } from "react-hook-form";
import { FormValues } from "../../page";
import { DataTable } from "./documents-table/data-table";
import { columns } from "./documents-table/columns";

export const EmployeeDocuments = () => {
  const form = useFormContext<FormValues>();

  const {
    fields: documentFields,
    append: appendDocument,
    remove: removeDocument,
    update: updateDocument,
  } = useFieldArray({
    name: "documents",
    control: form.control,
  });

  return (
    <div className="flex flex-col">
      <h2 className="text-lg font-medium">Documents</h2>

      <DataTable
        columns={columns}
        data={documentFields}
        removeDocumentRow={removeDocument}
        appendDocumentRow={appendDocument}
        updateDocumentRow={updateDocument}
      />
    </div>
  );
};
